"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Used as default secondary color
 * Palette is taken from mnemonics design manual and are based on the mnemonic
 * orange
 * All palettes are created using
 * https://material.io/design/color/the-color-system.html#tools-for-picking-colors
 */
const Orange = {
    50: "#FFF4E2",
    100: "#FFE3B6",
    200: "#FFD187",
    300: "#FFBE58",
    400: "#FFAF36",
    500: "#FFA120",
    600: "#FF951D",
    700: "#F8861A",
    800: "#F27718",
    900: "#E85E15",
    A100: "#FFD187",
    A200: "#FFA120",
    A400: "#F27718",
    A700: "#E85E15",
};
exports.default = Orange;
